import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetCustomersCurrentEmployeeQuery } from './store/services';
import ROUTES from '../../routes';

import cn from './new-application.module.css';

const NewApplication = (): React.JSX.Element => {
  const navigate = useNavigate();

  const {
    customersDictionaries: { activePermissions },
    newApplications: {
      list: { currentEmployee },
    },
  } = useAppSelector((state) => state);

  const match = useMatch(ROUTES.CUSTOMERS_NEW_APPLICATION);

  const [getCustomersCurrentEmployee] =
    useLazyGetCustomersCurrentEmployeeQuery();

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(PermissionEnum.APPLICATIONS_CUSTOMERS_LIST)
    ) {
      navigate(ROUTES.CUSTOMERS_NEW_APPLICATION_LIST);
    }
  }, [match, activePermissions]);

  useEffect(() => {
    if (!currentEmployee) {
      getCustomersCurrentEmployee();
    }
  }, [currentEmployee]);

  useEffect(() => {
    let title = 'Applications';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content;

  if (
    !activePermissions?.includes(PermissionEnum.APPLICATIONS_CUSTOMERS_LIST)
  ) {
    content = <PermissionDenied />;
  } else {
    content = (
      <div className={cn.newApplication}>
        <Outlet />
      </div>
    );
  }

  return content;
};

export default NewApplication;
